var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 8.00012C9.79098 8.00012 8.00012 9.79098 8.00012 12.0001C8.00012 14.2093 9.79098 16.0001 12.0001 16.0001C14.2093 16.0001 16.0001 14.2093 16.0001 12.0001C16.0001 9.79098 14.2093 8.00012 12.0001 8.00012ZM10.0001 12.0001C10.0001 10.8956 10.8956 10.0001 12.0001 10.0001C13.1047 10.0001 14.0001 10.8956 14.0001 12.0001C14.0001 13.1047 13.1047 14.0001 12.0001 14.0001C10.8956 14.0001 10.0001 13.1047 10.0001 12.0001Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5001 1.71149C12.5719 1.1756 11.4283 1.1756 10.5001 1.71149L3.83984 5.55679C2.91164 6.09269 2.33984 7.08307 2.33984 8.15487V15.8455C2.33984 16.9173 2.91164 17.9076 3.83984 18.4435L10.5001 22.2888C11.4283 22.8247 12.5719 22.8247 13.5001 22.2888L20.1604 18.4435C21.0886 17.9076 21.6604 16.9173 21.6604 15.8455V8.15487C21.6604 7.08307 21.0886 6.09269 20.1604 5.55679L13.5001 1.71149ZM11.5001 3.44355C11.8095 3.26491 12.1907 3.26491 12.5001 3.44354L19.1604 7.28884C19.4698 7.46748 19.6604 7.7976 19.6604 8.15487V15.8455C19.6604 16.2027 19.4698 16.5329 19.1604 16.7115L12.5001 20.5568C12.1907 20.7354 11.8095 20.7354 11.5001 20.5568L4.83984 16.7115C4.53044 16.5329 4.33984 16.2027 4.33984 15.8455V8.15487C4.33984 7.7976 4.53044 7.46748 4.83984 7.28884L11.5001 3.44355Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/options.ac5dbb87.svg";
export { ForwardRef as ReactComponent };